(function () {
  'use strict';

  if (window.__celestyEnrollerMetricaInitialized) {
    return;
  }

  window.__celestyEnrollerMetricaInitialized = true;

  var COUNTER_ID = 101581331;

  var flowActive = false;
  var resultSelected = false;
  var currentEnrollerName = '';

  var lastSearchValue = '';
  var lastSearchTime = 0;

  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function closestElement(target, selector) {
    if (!target) {
      return null;
    }

    if (target.nodeType === 3) {
      target = target.parentElement;
    }

    if (!target || typeof target.closest !== 'function') {
      return null;
    }

    return target.closest(selector);
  }

  function getCurrentEnrollerName() {
    var nameElement = document.querySelector(
      '.referral-banner__name'
    );

    return nameElement
      ? normalizeText(nameElement.textContent)
      : '';
  }

  function getSearchInput() {
    return document.querySelector(
      '.referral-banner__search-input'
    );
  }

  function sendYandexGoal(goalId) {
    if (typeof window.ym !== 'function') {
      console.warn(
        '[Enroller Tracking] Yandex Metrika bulunamadı:',
        goalId
      );

      return;
    }

    console.log(
      '[Enroller Tracking] Hedef çağrıldı:',
      goalId
    );

    window.ym(
      COUNTER_ID,
      'reachGoal',
      goalId,
      {},
      function () {
        console.log(
          '[Enroller Tracking] ✅ Yandex hedefi gönderildi:',
          goalId
        );
      }
    );
  }

  function trackSearch() {
    var searchInput = getSearchInput();
    var searchValue = searchInput
      ? normalizeText(searchInput.value)
      : '';

    if (!searchValue) {
      return;
    }

    /*
     * Enter sonrasında ayrıca arama butonu tetiklenirse,
     * aynı aramayı iki kez göndermeyi engeller.
     */
    var normalizedSearchValue = searchValue.toLowerCase();
    var currentTime = Date.now();

    if (
      normalizedSearchValue === lastSearchValue &&
      currentTime - lastSearchTime < 1500
    ) {
      return;
    }

    lastSearchValue = normalizedSearchValue;
    lastSearchTime = currentTime;

    flowActive = true;
    resultSelected = false;

    sendYandexGoal('change_enroller_search');
  }

  document.addEventListener(
    'click',
    function (event) {
      /*
       * 1. Change Enroller bağlantısına tıklama
       */
      var changeEnrollerLink = closestElement(
        event.target,
        '.referral-banner__change-link'
      );

      if (changeEnrollerLink) {
        currentEnrollerName = getCurrentEnrollerName();
        flowActive = true;
        resultSelected = false;

        sendYandexGoal('change_enroller_open');
        return;
      }

      /*
       * 2. Arama ikonuna tıklama
       */
      var searchButton = closestElement(
        event.target,
        '.referral-banner__search-button'
      );

      if (searchButton) {
        trackSearch();
        return;
      }

      /*
       * 3. Arama sonuçlarından kişiye tıklama
       */
      var resultsContainer = closestElement(
        event.target,
        '.referral-banner__search-results'
      );

      if (!resultsContainer) {
        return;
      }

      var resultItem = closestElement(
        event.target,
        [
          '[data-webalias]',
          '[data-referral]',
          '[data-enroller]',
          '[role="option"]',
          '.referral-banner__search-result',
          '.referral-banner__search-result-item',
          '.referral-banner__result',
          '.referral-banner__result-item',
          'button',
          'a',
          'li'
        ].join(',')
      );

      /*
       * Sonuç elemanının özel class'ı yoksa,
       * sonuç kutusundaki doğrudan üst elemanı yakala.
       */
      if (
        !resultItem ||
        !resultsContainer.contains(resultItem)
      ) {
        resultItem = closestElement(
          event.target,
          '.referral-banner__search-results > *'
        );
      }

      if (
        !resultItem ||
        !resultsContainer.contains(resultItem) ||
        !normalizeText(resultItem.textContent)
      ) {
        return;
      }

      currentEnrollerName = getCurrentEnrollerName();
      flowActive = true;
      resultSelected = true;

      sendYandexGoal('change_enroller_result_select');
    },
    true
  );

  /*
   * 4. Enter tuşuyla arama
   */
  document.addEventListener(
    'keydown',
    function (event) {
      var searchInput = closestElement(
        event.target,
        '.referral-banner__search-input'
      );

      if (!searchInput || event.key !== 'Enter') {
        return;
      }

      trackSearch();
    },
    true
  );

  /*
   * 5. Üstteki enroller adı gerçekten değiştiğinde
   * başarı hedefini gönder.
   */
  function initializeSuccessObserver() {
    var observerRoot = document.querySelector(
      '[id*="__celesty_teqnavi_referral_banner"]'
    );

    if (!observerRoot) {
      observerRoot = document.querySelector(
        '.referral-banner'
      );
    }

    if (!observerRoot) {
      setTimeout(initializeSuccessObserver, 500);
      return;
    }

    currentEnrollerName = getCurrentEnrollerName();

    var observer = new MutationObserver(function () {
      var newEnrollerName = getCurrentEnrollerName();

      if (
        !newEnrollerName ||
        newEnrollerName === currentEnrollerName
      ) {
        return;
      }

      var previousEnrollerName = currentEnrollerName;
      currentEnrollerName = newEnrollerName;

      /*
       * Yalnızca sonuçlardan bir kişi seçildikten sonra
       * isim değişmişse başarılı değişiklik sayılır.
       */
      if (!flowActive || !resultSelected) {
        return;
      }

      flowActive = false;
      resultSelected = false;

      sendYandexGoal('change_enroller_success');

      console.log(
        '[Enroller Tracking] ✅ Enroller değişti:',
        previousEnrollerName,
        '→',
        newEnrollerName
      );
    });

    observer.observe(observerRoot, {
      subtree: true,
      childList: true,
      characterData: true
    });

    console.log(
      '[Enroller Tracking] Takip aktif. Mevcut enroller:',
      currentEnrollerName
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSuccessObserver
    );
  } else {
    initializeSuccessObserver();
  }
})();
